module.exports = __webpack_public_path__ + "static/media/S2N6-4.85b07346.svg";